import ContactsBlock from './ContactsBlock';

export default ContactsBlock;
